module.exports = __webpack_public_path__ + "img/background-panel-hello--dark.f27018bc.svg";